import { useIsFetching } from 'react-query';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { useScrollTo } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramProgressOverview/useScrollTo';
import { ProgramCriticalAnalysisQueryKeys } from 'components/Dashboards/Project/Components/VersionCompare/queries/tableDataQuery';
import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import { TreeProgramTopHeader } from 'components/common';
import RenderCriticalAnalysisDelayDrivers from 'components/widgets/CriticalActivitiesAndDelayDrivers/RenderCriticalAnalysisDelayDrivers';
import RiskDensity from 'components/widgets/RiskDensity/RiskDensity';
import { SharedResourcesAvailabilityWrapper } from 'components/widgets/SharedResourcesAvailability/sharedResourcesAvailabilityWrapper';
import RenderTopDurationOverrunRisk from 'components/widgets/TopDurationOverrunRisk/topDurationOverrunRisk';

const CriticalityAndRiskPage = () => {
    useFullStoryPageView({ pageName: projectConfig.criticalityAnalysis.title });
    const isFetching = useIsFetching({
        predicate: (query) => {
            const key = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey;
            return ProgramCriticalAnalysisQueryKeys.includes(key);
        },
    });
    useScrollTo(isFetching);

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader pageTitle={projectConfig.criticalityAnalysis.title}>
                            <ShareInsightButton
                                title={projectConfig.criticalityAnalysis.title}
                                link={window.location.href}
                            />
                            <GlobalFilterButton />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <GlobalFilterComponent
                    defaultValues={{ milestoneFragnet: null, tags: [], activityCodes: [], wbs: null }}
                >
                    <MilestoneFragnetFilter name={'milestoneFragnet'} />
                    <TagsFilter name={'tags'} />
                    <ActivityCodesFilter name={'activityCodes'} />
                    <WbsFilter name={'wbs'} />
                </GlobalFilterComponent>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <RiskDensity />
                    <RenderCriticalAnalysisDelayDrivers />
                    <RenderTopDurationOverrunRisk />
                    <SharedResourcesAvailabilityWrapper />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={ProgramCriticalAnalysisQueryKeys} />
        </PageContainer>
    );
};

export default CriticalityAndRiskPage;
